import { registerNicePatternUI } from './ui-registration';

// Execute registration side-effect
registerNicePatternUI();
